<template>
	<tr v-bind:class="{ error }">
		<td>
			<p class="name">{{ patient.name }}</p>
			<p class="contact email">{{ patient.email }}</p>
			<p class="contact phone">{{ patient.phone }}</p>
		</td>
		<td>
			<!-- <el-button class="add-event" type="primary" size="mini"
				@click="addEvent">
				<i class="el-icon-plus"></i>&nbsp;
				<strong>Add Event</strong>
			</el-button> -->

			<div class="event" v-for="(event, index) in patient.event">
				<template v-if="event">
					<p v-if="event.note" class="note">
						<span v-for="note in event.note">{{ note }}</span>
					</p>
					<el-select size="small" v-model="event.id" placeholder="Select Event">
					    <el-option
					      v-for="e in events"
					      :key="e.id"
					      :label="e.name"
					      :value="e.id">
					    </el-option>
					</el-select>
					&nbsp;
					<el-date-picker
					  size="small"
				      v-model="event.time"
					  type="date"
					  format="MM/dd/yyyy"
				      placeholder="Event date">
				    </el-date-picker>
					&nbsp;
					<!-- <el-button size="small" @click="removeEvent(index)" icon="el-icon-close" circle></el-button> -->
				</template>
			</div>
		</td>
	</tr>
</template>

<script>
export default {
	name: 'add-schedule-row',
	props: ['value', 'first', 'error', 'importExists', 'importError', 'enrolling', 'events'],
	data() {
		return {
			patient: this.value,
			undo: false
		}
	},
	mounted() {
	},
	methods: {
		changed() {
			this.$emit('value', this.patient)
		},
		remove() {
			this.$emit('remove')
		},
		addEvent() {
			this.patient.event.push({
				id: null,
				time: null,
				match: null
			})
		},
		removeEvent(index) {
			this.patient.event.splice(index, 1)
		}
	},
	computed: {
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
.name {
	font-weight: 700;
}
.contact {
	font-size: 12px;
}
.note {
	padding: 0;
	color: #4f4f4f;
	// background: #f0f0f0;
	// padding: 2px 10px;
	border-radius: 4px;
	line-height: 20px;

	span {
		margin: 0 4px 0 0;
		border: solid 1px #e0e0e0;
		background: #f0f0f0;
		padding: 4px 8px;
	}

	> strong {
		color: #000000;
		font-weight: 700;
	}
}
.event {
}
.add-event {
	float: right;
	margin-top: -6px;
	margin-right: -11px;
	border-radius: 3px;
}
</style>
